module.exports = __webpack_public_path__ + "img/users-solid.f9081945.svg";